import { useCallback } from 'react';
import { useMytaverse } from '@providers/MytaverseProvider';
import { useAvaturnHelperType } from '@features/avaturn/pages/Avaturn/interfaces';

import ParticipantsService from '@services/ParticipantsService';
import { AvatarTypes } from '@interfaces/avatar';
import AvaturnService from '@features/avaturn/services/AvaturnService';
import { MytaverseLogger } from '@helpers/logger';
import { getCatchErrorMessage } from '@helpers/error';
import useUserProfileHelper from '@features/avaturn/hooks/useUserProfileHelper';

//TODO: remove all mentions about ixr
const useAvaturnHelper: useAvaturnHelperType = () => {
  const { configs, user } = useMytaverse();

  const { getProcessedBrand, getGender } = useUserProfileHelper();

  const getToken = useCallback(() => {
    return configs?.avaturn?.tokens?.mytaverse;
  }, [configs]);

  const getAssetParams = useCallback(
    () => ({
      gender: user?.gender?.toUpperCase() || 'M',
    }),
    [user?.gender],
  );

  const getChangeAvatarParams = useCallback(() => {
    //TODO: should be implemented
    return null;
  }, []);

  const deleteAvatar = useCallback(async (avatarId: string, brand: string) => {
    return await ParticipantsService.deleteParticipantAvatarFromList({
      avatarType: AvatarTypes.AVATURN,
      avatarId,
      brand,
      hardDelete: true,
    });
  }, []);

  const exportPreprocess = useCallback(async (avaturnId: string) => {
    try {
      return await AvaturnService.deleteAvaturn(avaturnId);
    } catch (e) {
      MytaverseLogger.log(`deleteAvaturn error: ${getCatchErrorMessage(e)}`);
    }
  }, []);

  return {
    getProcessedBrand,
    getGender,
    getToken,
    getAssetParams,
    getChangeAvatarParams,
    deleteAvatar,
    exportPreprocess,
  };
};

export default useAvaturnHelper;
